import { useCallback } from 'react';

import {
	type CopyLinkButtonClickedArgs,
	onCopyLinkButtonClicked,
} from '../../../common/utils/events/copy-link-button-clicked';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';

/**
 * @returns a callback to fire an event when the result
 * is clicked by the user.
 */
export const useFireCopyLinkButtonClicked: (
	location: CopyLinkButtonClickedArgs['location'],
) => () => void = (location: CopyLinkButtonClickedArgs['location']) => {
	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();

	return useCallback(() => {
		fireAnalyticsEvent(
			onCopyLinkButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...getExtensionData(commonAttributes.isCQL),
				},
				nonPrivacySafeAttributes,
				location,
			}),
		);
	}, [fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes, location]);
};
